import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isMobileOnly } from 'react-device-detect';
import StartAgain from './StartAgain';
import GetInTouch from './GetInTouch';

function Footer({ result }) {
  const { t } = useTranslation();

  const showCookieSettings = (e) => {
    e.preventDefault();
    window.OneTrust.ToggleInfoDisplay();
  };

  const renderFooterInfo = () => {
    if (!isMobileOnly || result) {
      return (
        <div className="container-fluid border-top py-3">
          <div className="container font-smaller">
            <div className="d-md-flex justify-content-between">
              <p>
                &copy;
                {`${new Date().getFullYear()} ${t('footer.p1')}`}
              </p>
              <span className="d-md-flex flex-fill justify-content-md-end">
                <a className="btn-link" href={t('startPage.privacyPolicyUrl')}>
                  {t('startPage.privacyPolicy')}
                </a>
                |
                <a className="btn-link" href={t('startPage.legalNoticeUrl')}>
                  {t('startPage.legalNotice')}
                </a>
                |
                <a
                  className="btn-link"
                  role="button"
                  href="/"
                  onClick={showCookieSettings}
                >
                  {t('footer.cookieSettings')}
                </a>
              </span>
            </div>
            <div className="divider border-top my-3" />
            <p>
              {`${t('footer.p2')} `}
              <a className="btn-link" href={`https://${t('footer.site')}`}>
                {t('footer.site')}
              </a>
            </p>
          </div>
        </div>
      );
    }
    return (<></>);
  };

  return (
    <footer className="footer mt-auto">
      {result && (
        <>
          <div className="container">
            <StartAgain />
          </div>
          <GetInTouch />
        </>
      )}
      {renderFooterInfo()}
    </footer>
  );
}

Footer.propTypes = {
  result: PropTypes.bool,
};

Footer.defaultProps = {
  result: false,
};

export default Footer;
